import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as $ from "jquery";
import * as entities from "entities";
import * as _ from "lodash";
import * as entitiesE from "entitiesE";
import * as toastr from "toastr";
import {
  complaint_request_header,
  extended_request,
  personExtended,
  product,
  productExtended,
  ProductSearchCriteria,
  product_related_places,
  RequestSearchCriteria,
  attachment_wrapper,
  request_type,
  searchResult,
  searchResultArray,
  TaskTrackingUrl,
  task_management,
  warranty_request,
  task_management_extended,
  request_dto,
  ComplaintReqSearchCriteria,
  complaint_request_lines,
  team_member,
  c_sap_sales_order,
} from "organized";
import labels from "app/labels";
import { AttachmentResultDTO, downloadAttachmentFromBase64 } from "services";
import { portalHttpService } from "./_common/httpService";
import { GenericPageType } from "components/request-generic/PageType";
import { BaseService } from "./_common/_baseService";
export enum RequestType {
  GENERIC,
  WARRANTY,
  COMPLAINT,
}

class RequestService extends BaseService {
  constructor() {
    super("request");
  }

  public getRequestScreenData = async (requestType: RequestType): Promise<void> => {
    let requiredLookups = [];
    switch (requestType) {
      case RequestType.GENERIC:
      case RequestType.WARRANTY: {
        requiredLookups = [
          "ACCESS_GROUP",
          "C_ESCALATION_STATUS",
          "C_WTY_CLAIM_TYPE",
          "C_WTY_CLAIM_STATUS",
          "PLACEPERSONS",
          "C_IMPACT",
          "C_PHENOMENON_CLASS",
          "C_PRIOIMPACTURGENCY",
          "C_PHENOMENOM_CODE",
          "MODEL_TYPE",
          "C_NETWORK_INTERFACE",
          "C_CONNECTION",
          "C_OPERATING_SYSTEM",
          "C_WTY_CLAIM_ACTION",
          "C_WTY_CLAIM_CUSTOMER_STATUS",
          "REQ_CLASS",
          "REQ_TYPE",
          "REQ_STATUS",
          "REQ_GROUP",
          "REQ_CATEGORY",
          "TASK_TYPE",
        ];
        break;
      }
      case RequestType.COMPLAINT: {
        requiredLookups = [
          "C_COMPLAINT_TYPE",
          "C_COMPLAINT_CMPL_STATUS",
          "C_COMPLAINT_STATUS",
          "C_TRANSPORT_DAMAGE_TYPES",
          "PLACEPERSONS",
        ];
        break;
      }
    }
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });

    const result = await portalHttpService.post(
      system.apiURL() + `api/${this.controllerName}/GetRequestScreenData`,
      data,
    );
    this.setLookupData(lookupsToFetch, result);
  };

  public getGenericRequestById = async (request_id: string, pageType: GenericPageType) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetGenericRequestById/`);
    myUrlWithParams.searchParams.append("request_id", request_id);
    myUrlWithParams.searchParams.append("page", pageType);

    const requestResult = await portalHttpService.get<any>(myUrlWithParams.toString());

    let request: extended_request = null;
    if (requestResult) {
      request = new extended_request(requestResult);
      if (requestResult.readonly) {
        request.readonly(true);
      }
    }
    let task_attachments = new Array();
    let tasks: Array<task_management_extended> = null;
    if (requestResult?.task) {
      if (Array.isArray(requestResult.task)) {
        _.each(requestResult.task, (task) => {
          if (task.task_attachment?.length > 0) task_attachments.push(...task.task_attachment);
        });
        tasks = _.map(requestResult.task, (o) => {
          return new task_management_extended(o);
        });
      } else {
        if (requestResult.task.task_attachment?.length > 0)
          task_attachments.push(...requestResult.task.task_attachment);
        tasks = [new task_management_extended(requestResult.task)];
      }
    }

    return { request, task_attachments, tasks };
  };

  // Get My Requests or My Products Requests list
  public getMyRequests = async (criteria: RequestSearchCriteria): Promise<searchResult<extended_request[]>> => {
    const data: searchResult<any[]> = await portalHttpService.post(
      `${this.baseApiUrl()}/GetMyRequests`,
      ko.toJSON(criteria),
    );
    let requests = data.result?.map((request) => new extended_request(request));

    return new searchResult<extended_request[]>({ result: requests, count: data.count });
  };

  public getPortalRequests = async (message_id: string, page: string = null): Promise<request_type[]> => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetRequestTypes/`);
    myUrlWithParams.searchParams.append("type", message_id);
    if (page) {
      myUrlWithParams.searchParams.append("page", page);
    }

    const result: any[] = await portalHttpService.get(myUrlWithParams.toString());
    return result.map((rt) => new request_type(rt));
  };

  getUserAddresses = async (): Promise<any[]> => {
    return await portalHttpService.get(`${this.baseApiUrl()}/GetUserAddresses`);
  };

  checkSerialConstraints = async (
    request_type: string,
    product_id: string,
  ): Promise<{
    isValid: boolean;
    addressConstraints: string[];
  }> => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/CheckSerialConstraints`);
    myUrlWithParams.searchParams.append("request_type", request_type);
    myUrlWithParams.searchParams.append("product_id", product_id);
    return await portalHttpService.get<any>(myUrlWithParams.href);
  };

  public exportFile = async (
    criteria: RequestSearchCriteria,
    headers: { label: string; css: KnockoutComputed<string>; sortMe: () => void }[],
    offset: any,
  ): Promise<void> => {
    const labelsResult = headers.map((header) => header.label).join(",");
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/ExportFile/`);
    myUrlWithParams.searchParams.append("criteria", ko.toJSON(criteria));
    myUrlWithParams.searchParams.append("labelsString", labelsResult);
    myUrlWithParams.searchParams.append("timeZone", `${offset}`);

    const fileResult: AttachmentResultDTO = await portalHttpService.get(myUrlWithParams.href);
    downloadAttachmentFromBase64(fileResult);
  };

  public searchProducts = async (criteria: ProductSearchCriteria): Promise<searchResult<productExtended[]>> => {
    const result = await portalHttpService.post<any>(`${this.baseApiUrl()}/SearchProducts`, ko.toJSON(criteria));
    result.result = result.result.map((pr) => new productExtended(pr));
    return result;
  };

  public getWtySAPHistory = async (request_id: string): Promise<c_sap_sales_order[]> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/request/GetWtySAPHistory",
      ko.toJSON({ request_id: request_id }),
    );
    let sapHistory: c_sap_sales_order[] = [];
    if (data && data.c_sap_sales_order && data.c_sap_sales_order.c_sap_sales_order) {
      if (Array.isArray(data.c_sap_sales_order.c_sap_sales_order)) {
        sapHistory = _.map(data.c_sap_sales_order.c_sap_sales_order, (o) => {
          return new c_sap_sales_order(o);
        });
      } else {
        sapHistory = [new c_sap_sales_order(data.c_sap_sales_order.c_sap_sales_order)];
      }
    }
    return sapHistory;
  };

  public cancelRequest = async (request_id: string) => {
    await portalHttpService.post<any>(system.apiURL() + "api/request/CancelRequest", ko.toJSON({ request_id }));
  };

  public searchRequests = async (criteria: RequestSearchCriteria): Promise<searchResultArray<warranty_request>> => {
    if (system.PortalType() == "PARTNER") {
      criteria.req_type("KYO_WTY_CLAIM");
    }
    let jsonData = ko.toJSON({ criteria: criteria, genericRequests: false });
    const data = await portalHttpService.post<any>(system.apiURL() + "api/request/SearchRequests", jsonData);
    let requests = _.map(data.result, (r) => {
      return new warranty_request(r);
    });
    return new searchResultArray({ result: requests, count: data.count });
  };

  public getJournalNotes = async (request_id: string): Promise<entitiesE.screenNote[]> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/request/GetJournalNotes",
      ko.toJSON({ request_id: request_id }),
    );
    let notesUpdate = entities.loadRelation(data, "screenNote", "array");
    return notesUpdate();
  };

  public escalateRequest = async (request_id: string, reason: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/request/escalateRequest",
      ko.toJSON({ request_id: request_id, reason: reason }),
    );
  };

  public escalateMyRequest = async (request_id: string, reason: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/request/escalateMyRequest",
      ko.toJSON({ request_id: request_id, reason: reason }),
    );
  };

  public subscribe = async (request_id: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/subscribe",
      ko.toJSON({ request_id: request_id }),
    );
  };

  public unsubscribe = async (request_id: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/IncidentRequest/unsubscribe",
      ko.toJSON({ request_id: request_id }),
    );
  };

  public addNote = async (
    request_id: string,
    note: string,
    type: string,
    key: string,
  ): Promise<entitiesE.screenNote[]> => {
    const data = ko.toJSON({ request_id: request_id, note: note, type: type, key: key });

    const result = await portalHttpService.post(system.apiURL() + "api/request/addNote", data);

    let notesUpdate = entities.loadRelation(result, "screenNote", "array");
    toastr.success(labels.descr("cc_Note_Added"));

    return notesUpdate();
  };

  public updatePriority = async (request_id: string, priority: string): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/request/updatePriority",
      ko.toJSON({ request_id: request_id, priority: priority }),
    );
  };

  public changeStatus = async (request_id: string, to_status: string, reason: string): Promise<void> => {
    await portalHttpService.post(
      system.apiURL() + "api/request/changeStatus",
      ko.toJSON({ request_id: request_id, to_status: to_status, reason: reason }),
    );
  };

  public exportComplaintFile = async (
    criteria: ComplaintReqSearchCriteria,
    headers: { label: string; css: KnockoutComputed<string>; sortMe: () => void }[],
    offset: any,
  ): Promise<void> => {
    let url = "criteria=[" + ko.toJSON(criteria) + ",labels:";
    for (let header of headers) {
      url += labels.descr(header.label) + ",";
    }
    if (url.endsWith(",")) {
      url = url.substring(0, url.length - 1);
    }
    url += "}timeZone:" + offset;
    url += "]";

    const fileResult: AttachmentResultDTO = await portalHttpService.get(
      `${this.baseApiUrl()}/ExportComplaintFile?${url}`,
    );
    downloadAttachmentFromBase64(fileResult);
  };

  private setLookupData = (lookupsToFetch: string[], results: any) => {
    _.each(lookupsToFetch, (lookupName) => {
      let list = results[lookupName];

      if (list) {
        if (lookupName == "PLACEPERSONS") {
          if (!Array.isArray(list.person)) {
            list["placepersons"] = [list["person"]];
          } else {
            list["placepersons"] = list["person"];
          }
          delete list["person"];
          _.each(list.placepersons, (p) => {
            p.description = p.first_name + " " + p.last_name;
            p.placepersons = p.person_id;
          });
        }
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };

  public getRequestTemplates = async (
    request_model: string,
    request_type: string,
    request_class: string,
    sn: string,
    req_categories: string,
    product_id: string,
  ) => {
    let data = ko.toJSON({
      model_id: request_model ? request_model : "",
      request_type: request_type,
      request_class: request_class,
      serial_id: sn,
      req_categories: req_categories,
      product_id: product_id,
    });

    const response = await portalHttpService.post<any>(`${system.apiURL()}api/Request/GetRequestTemplate`, data);
    let requestTemplates = [];
    let contacts = {};
    let equivalence_extended = response?.k_model_equivalence_extended ?? [];

    if (response?.k_request_templates) {
      requestTemplates =
        response?.k_request_templates?.map((template) => new entities.request_template(template)) ?? [];
    }

    //#region Set Contacts
    if (response?.contact?.contact?.person) {
      if (Array.isArray(response.contact.contact.person)) {
        contacts["company"] = response.contact.contact.person;
      } else {
        contacts["company"] = [response.contact.contact.person];
      }
    }
    if (response.contact?.product_contact?.contact) {
      if (Array.isArray(response.contact.product_contact.contact)) {
        contacts["product"] = response.contact.product_contact.contact;
      } else contacts["product"] = [response.contact.product_contact.contact];
    }
    //#endregion
    return {
      requestTemplates,
      contacts,
      equivalence_extended,
      contractValidity: response?.contractValidity,
    };
  };

  public searchProductContactList = async (
    model_id: string,
    request_type: string,
    request_class: string,
    sn: string,
  ) => {
    const data = await portalHttpService.post<any>(
      `${system.apiURL()}api/Request/GetRequestContactList`,
      ko.toJSON({ model_id: model_id, request_type: request_type, request_class: request_class, serial_id: sn }),
    );

    let contacts = new Array();
    if (data?.results?.contact?.person) {
      if (Array.isArray(data.results.contact.person)) contacts["company"] = data.results.contact.person;
      else contacts["company"] = [data.results.contact.person];
    }
    if (data?.results?.product_contact?.contact) {
      if (Array.isArray(data.results.product_contact.contact))
        contacts["product"] = data.results.product_contact.contact;
      else contacts["product"] = [data.results.product_contact.contact];
    }

    return contacts;
  };

  public getUserPredefinedTeams = async (): Promise<team_member[]> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/" + this.controllerName + "/GetUserPredefinedTeams",
    );
    let userTeams: team_member[];
    if (data.person && data.person.person && data.person.person.team_member) {
      if (Array.isArray(data.person.person.team_member)) {
        userTeams = _.map(data.person.person.team_member, (o) => {
          return new team_member(o);
        });
      } else {
        userTeams = [new team_member(data.person.person.team_member)];
      }
    }

    return userTeams;
  };

  public getTasksForRequest = async (request_id: string) => {
    let data = ko.toJSON({ request_id: request_id });
    const result = await portalHttpService.post<any>(`${system.apiURL()}api/Request/SearchTasksForRequest`, data);
    var data1: Array<Object> = new Array();
    if (result.result.results.task.task)
      if (!(result.result.results.task.task instanceof Array)) {
        data1 = new Array(new task_management(result.result.results.task.task));
      } else {
        data1 = _.map(result.result.results.task.task, (entity) => new task_management(entity));
      }

    return new entities.SearchResult({ data: data1, count: result.count });
  };

  public searchProduct = async (serial_id: string): Promise<product> => {
    let data = ko.toJSON({ serial_id: serial_id });
    let url = `${system.apiURL()}api/Request/SearchProduct`;
    const result = await portalHttpService.post<any>(url, data);

    if (result.product.product) {
      return new product(result.product.product);
    } else {
      throw new Error("No matching serial found");
    }
  };

  public searchModelAutocomplete = async (model_id: string, filterCategory: string): Promise<entities.SearchResult> => {
    let data = ko.toJSON({ model_id, Rows: 10, Page: 0, filterCategory });
    let url = `${system.apiURL()}api/Request/SearchModelAutocomplete`;

    const result = await portalHttpService.post<any>(`${url}`, data);
    let models: entities.SearchResult;
    if (result?.result?.models)
      models = new entities.SearchResult({ data: result.result.models, count: result.result.models.length });
    else models = new entities.SearchResult({ data: [], count: 0 });
    return models;
  };

  public searchProductAutocomplete = async (
    serial_id: string,
    filterCategory: string,
    model_id: string,
  ): Promise<searchResult<any[]>> => {
    const data = ko.toJSON({
      serial_id: serial_id,
      filterCategory: filterCategory,
      model_id: model_id,
    });
    let url = `${this.baseApiUrl()}/SearchProductAutocomplete`;
    const result = await portalHttpService.post<any>(`${url}`, data);
    return new searchResult<any[]>({ result: result?.result ?? [], count: result?.count ?? 0 });
  };

  public searchProductRelatedPlaces = async (product_id: string): Promise<product_related_places[]> => {
    let requiredLookups = ["C_PRODUCT_PLACE_REL_TYPE"];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let params = ko.toJSON({ product_id: product_id, requiredLookups: lookupsToFetch });

    const result = await portalHttpService.post<any>(`${this.baseApiUrl()}/SearchProductRelatedPlaces`, params);

    this.setLookupData(lookupsToFetch, result.results);

    const placeRels: product_related_places[] = result.results.c_product_place_rel.map(
      (pr) => new product_related_places(pr),
    );

    placeRels.forEach((pr) => {
      let description = LookupStorage.lookupStorage.getLookupItemDescription("C_PRODUCT_PLACE_REL_TYPE", pr.rel_type());

      if (!description) {
        description = pr.rel_type();
      }

      pr.rel_type_description(description);
    });
    return placeRels;
  };

  public saveGenericRequest = async (
    req: request_dto,
    newReq,
    product: product,
    partsList: KnockoutObservableArray<any>,
    selectedAddressId: string,
  ) => {
    let data = ko.toJSON({
      request: req,
      parameters: newReq,
      place: req.place_id(),
      product: product,
      partsList,
      selectedAddressId,
    });
    let url = `${this.baseApiUrl()}/SaveGenericRequest`;
    const result = await portalHttpService.post<any>(`${url}`, data);
    let person = new personExtended({});
    if (typeof result.results.person !== "undefined") {
      person = new personExtended(result.results.person);
    }
    return { request: result.results.request, person: person };
  };

  public getRequestNotes = async (request_id): Promise<entitiesE.screenNote[]> => {
    let data = ko.toJSON({ request_id: request_id });
    let url = `${system.apiURL()}api/Request/GetRequestNotes`;

    const response = await portalHttpService.post<any>(`${url}`, data);
    let notesUpdate = entities.loadRelation(response, "screenNote", "array");
    return notesUpdate();
  };

  public addRequestNoteForTask = async (
    task_id: string,
    note: string,
    type: string,
    key: string,
  ): Promise<entitiesE.screenNote[]> => {
    const data = ko.toJSON({ request_id: task_id, note: note, type: type, key: key });
    const result = await portalHttpService.post<any>(
      system.apiURL() + `api/${this.controllerName}/AddRequestNoteForTask`,
      data,
    );
    let notesUpdate = entities.loadRelation(result, "screenNote", "array");
    toastr.success(labels.descr("cc_Note_Added"));
    return notesUpdate();
  };

  public createComplaint = async (original_delivery_order, complaint_type, owner_ref_no, is_goodwill): Promise<any> => {
    let data = ko.toJSON({
      original_delivery_order: original_delivery_order ? original_delivery_order : "",
      complaint_type: complaint_type ? complaint_type : "",
      owner_ref_no: owner_ref_no ? owner_ref_no : "",
      is_goodwill: is_goodwill ? "Y" : "N",
    });

    const result = await portalHttpService.post<any>(
      system.apiURL() + `api/${this.controllerName}/CreateComplaint`,
      data,
    );
    if (result && result.result && result.result.header) {
      return result.result;
    } else {
      throw new Error(labels.descr("cc_P_COMPLAINT_NOT_CREATED"));
    }
  };

  public modifyComplaintLines = async (
    header: complaint_request_header,
    items: complaint_request_lines[],
  ): Promise<void> => {
    let data = ko.toJSON({ header: header, items: items });
    await portalHttpService.post(`${this.baseApiUrl()}/ModifyComplaintLines`, data);
  };

  public SaveComplaintAttachment = (complaint_id, attachment): Promise<{}> => {
    return new Promise((resolve, reject) => {
      var formData = new FormData();
      formData.append("imageData", dataURLtoBlob(attachment.attachment.file.filedata));
      formData.append("request_id", complaint_id);
      formData.append("attachment_name", attachment.attachment.attachment_name);
      formData.append("attachment_type", attachment.attachment.attachment_type);
      formData.append("file_type", attachment.attachment.file_type);
      formData.append("attachment_description", attachment.attachment.attachment_description);

      $.ajax({
        type: "POST",
        url: system.apiURL() + `api/${this.controllerName}/SaveComplaintAttachment`,
        data: formData,
        contentType: false,
        processData: false,
        success: function (data) {
          resolve(data.c_complaint_attachment);
        },
        error: function (data) {
          console.error(data);
          reject(labels.descr("cc_P_ERROR_WHILE_UPLOADING_ATTACHMENT"));
        },
      });
    });
  };

  public searchComplaintRequests = async (criteria: ComplaintReqSearchCriteria): Promise<entities.SearchResult> => {
    let jsonData = ko.toJSON({ criteria: criteria }, (k, v) => (v === "" ? undefined : v));
    const result = await portalHttpService.post<any>(system.apiURL() + "api/request/SearchComplaintRequests", jsonData);
    let requests = _.map(result.result.request, (r) => {
      return new complaint_request_header(r);
    });
    return new entities.SearchResult({ data: requests, count: result.count });
  };

  public getComplaint = async (complaint_id): Promise<any> => {
    let data = ko.toJSON({ complaint_id: complaint_id });
    const result = await portalHttpService.post<any>(system.apiURL() + `api/${this.controllerName}/GetComplaint`, data);

    if (result && result.result && result.result.header) {
      return result.result;
    } else {
      throw new Error(labels.descr("cc_P_COMPLAINT_NOT_FOUND"));
    }
  };

  public cancelComplaint = async (complaint_id): Promise<any> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + `api/${this.controllerName}/CancelComplaint`,
      ko.toJSON({ complaint_id: complaint_id }),
    );
    if (data) {
      return data;
    } else {
      throw new Error(labels.descr("cc_P_COMPLAINT_NOT_FOUND"));
    }
  };

  public addComplaintNote = async (
    complaint_id: string,
    note: string,
    type: string,
  ): Promise<entitiesE.screenNote[]> => {
    var data = ko.toJSON({ complaint_id: complaint_id, note: note, type: type });
    return await portalHttpService.post<any>(system.apiURL() + "api/request/AddComplaintNote", data);
  };

  public checkComplaintsForOrder = async (order_id: string): Promise<any> => {
    var data = ko.toJSON({ order_id: order_id });
    const result = await portalHttpService.post<any>(system.apiURL() + "api/request/CheckComplaintsForOrder", data);

    if (result["c_complaint_request"] && result["c_complaint_request"]["c_complaint_request"]) {
      return result["c_complaint_request"]["c_complaint_request"];
    } else {
      return [];
    }
  };

  public getTasksTrackingUrl = async (request_id: string): Promise<TaskTrackingUrl[]> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/request/GetTasksTrackingUrl",
      ko.toJSON({ request_id }),
    );
    let urls: TaskTrackingUrl[] = [];
    if (data?.c_tracking_url_view?.c_tracking_url_view) {
      if (
        Array.isArray(data.c_tracking_url_view.c_tracking_url_view) &&
        data.c_tracking_url_view.c_tracking_url_view.length > 1
      ) {
        urls = _.map(data.c_tracking_url_view.c_tracking_url_view, (o) => {
          return new TaskTrackingUrl(o);
        });
      } else {
        urls = [new TaskTrackingUrl(data.c_tracking_url_view.c_tracking_url_view)];
      }
    }
    return urls;
  };

  public acknowledgeTaskRequestNotification = async (
    request_id: string,
    notification_type: string,
    task_ids: string,
  ): Promise<void> => {
    await portalHttpService.post<any>(
      system.apiURL() + "api/request/AcknowledgeTaskRequestNotification",
      ko.toJSON({ request_id, notification_type, task_ids }),
    );
  };

  public acknowledgeComplaintNotification = async (
    complaint_id: string,
    notification_type: string,
  ): Promise<boolean | string> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/request/AcknowledgeComplaintNotification",
      ko.toJSON({ complaint_id, notification_type }),
    );

    if (data?.successful) {
      return true;
    }

    return false;
  };

  public getSoftwareApplications = async (): Promise<any[]> => {
    return await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetSoftwareApplications`);
  };

  public getSoftwareModules = async (application_code: string): Promise<any[]> => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetSoftwareModules/`);
    myUrlWithParams.searchParams.append("parent_code", application_code);
    let result: any[] = await portalHttpService.get(myUrlWithParams.toString());

    result = result.map((r) => {
      r.description = labels.descr(r.code_value);
      return r;
    });

    return result;
  };
}

function dataURLtoBlob(dataurl: string) {
  if (!(dataurl === "data:")) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  } else {
    throw new Error("cc_P_EMPTYFILE");
  }
}

export const requestService = new RequestService();
